import { render, staticRenderFns } from "./PurchaseListSelectionToolbar.vue?vue&type=template&id=872ec37e&scoped=true"
import script from "./PurchaseListSelectionToolbar.vue?vue&type=script&lang=ts"
export * from "./PurchaseListSelectionToolbar.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseListSelectionToolbar.vue?vue&type=style&index=0&id=872ec37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872ec37e",
  null
  
)

export default component.exports